export default __webpack_public_path__ + "static/media/share.5bc32a9f.svg";